/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function(){
  
  $('.showMore').on('click',function(e){
    e.preventDefault();
    $(this).closest('.showing').toggleClass('showFull');
  });
  

  $('.productMain').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.productThumb',
    dots: false,
    dots: true
  });
  $('.productThumb').slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.productMain'
  });

  $('.priceReview .star-rating').on('click', function(){
    if($('#shopify-section-guarantee').length) {
      var hh = $('.posSty').height();
      $('html, body').animate({ scrollTop: $('#shopify-section-guarantee').offset().top-hh }, 1000);
    }
  });
  
  
  $('.customScroll').on('click', function(){
    var btn = $(this);
    var fw = $(this).closest('.ProductListScroll')[0].scrollWidth;
    var ww = $(this).closest('.ProductListWrapper')[0].clientWidth;
    var sc = fw-ww;
    var container = $(this).closest('.ProductListScroll')[0];
    var scrollAmount = 0;

    var slideTimer = setInterval(function(){
      if(btn.hasClass('slick-next')) {
        container.scrollLeft += 10;
        btn.closest('.ProductListScroll').find('.slick-prev').removeClass('slick-disabled');
      } else {
        container.scrollLeft -= 10;
        btn.closest('.ProductListScroll').find('.slick-next').removeClass('slick-disabled');
      }
      
      scrollAmount += 10;
      if(scrollAmount >= ww-60){
        window.clearInterval(slideTimer);
      }
    }, 5);
  });
  
  $(".ProductListScroll").on("scroll", function (e) {
    var horizontal = e.currentTarget.scrollLeft;
    if(horizontal==0) {
      $(this).find('.slick-prev').addClass('slick-disabled');
    } else {
      $(this).find('.slick-prev').removeClass('slick-disabled');
    }
    var fw = $(this)[0].scrollWidth;
    var ww = $(this)[0].clientWidth;
    if((horizontal+ww)==fw) {
      $(this).find('.slick-next').addClass('slick-disabled');
    } else {
      $(this).find('.slick-next').removeClass('slick-disabled');
    }
  });
  
  $('.ProductListScroll').each(function(){
    var fw = $(this)[0].scrollWidth;
    var ww = $(this).closest('.ProductListWrapper')[0].clientWidth;
    var s = parseInt(fw/ww)+1;
    $(this).attr('data-scroll',s);
    if(s>1) {
      $(this).find('.slick-next').removeClass('slick-disabled');
    }
  });

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  $('.closeBar').on('click', function(){
    $('#shopify-section-announcement').slideUp();
    setCookie('ansBar','hide',7);
  });
  
  if(!getCookie('ansBar')) {
    $('#shopify-section-announcement').show();
  }

  
  
});